import React, { useEffect, useState } from 'react';
import axios from '../../axios/axiosconf';
import {
    filtrarPacientesParaModal,
    getNombreClienteFacturacion,
} from '../../../utils/busquedaPacienteFacturacion';
import './ModalSeleccionPaciente.css';

const PACIENTES_POR_PAGINA = 8;

/**
 * Modal reutilizable para elegir un paciente (persona natural).
 * Muestra nombre en UI; el padre guarda paciente.id.
 */
function ModalSeleccionPaciente({ show, onHide, onSelect, titulo = 'Seleccionar paciente' }) {
    const [pacientes, setPacientes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [busqueda, setBusqueda] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);

    useEffect(() => {
        if (!show) {
            setBusqueda('');
            setPaginaActual(1);
            return;
        }

        const userdataRaw = localStorage.getItem('userdata');
        if (!userdataRaw) return;

        const userdata = JSON.parse(userdataRaw);
        setLoading(true);
        axios.get('/pacientes', { params: { uid: userdata.user_id } })
            .then((res) => {
                const lista = Array.isArray(res.data) ? res.data : [];
                setPacientes(lista);
            })
            .catch(() => setPacientes([]))
            .finally(() => setLoading(false));
    }, [show]);

    useEffect(() => {
        setPaginaActual(1);
    }, [busqueda]);

    if (!show) return null;

    const filtrados = filtrarPacientesParaModal(pacientes, busqueda);
    const totalPaginas = Math.max(1, Math.ceil(filtrados.length / PACIENTES_POR_PAGINA));
    const pagina = Math.min(Math.max(1, paginaActual), totalPaginas);
    const inicio = (pagina - 1) * PACIENTES_POR_PAGINA;
    const paginaItems = filtrados.slice(inicio, inicio + PACIENTES_POR_PAGINA);

    const handleSelect = (paciente) => {
        onSelect(paciente);
        onHide();
    };

    return (
        <div
            className="modal fade show msp-modal-paciente"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1055, overflowY: 'auto' }}
            tabIndex="-1"
            role="dialog"
            onClick={onHide}
        >
            <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content border-0">
                    <div className="modal-header msp-paciente-head">
                        <h5 className="modal-title mb-0">
                            <i className="fas fa-user-injured mr-2 text-info"></i>
                            {titulo}
                        </h5>
                        <button type="button" className="close" onClick={onHide} aria-label="Cerrar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body msp-paciente-body">
                        <div className="form-group mb-3">
                            <label className="mb-1 d-block small font-weight-bold text-muted">Buscar</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Nombre o documento"
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div className="msp-paciente-table-wrap table-responsive">
                            <table className="table table-hover table-sm table-borderless mb-0">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Documento</th>
                                        <th className="text-center" style={{ width: 56 }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="3" className="text-center text-muted py-4">Cargando…</td>
                                        </tr>
                                    ) : filtrados.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="text-center text-muted py-4">
                                                No hay pacientes que coincidan con la búsqueda.
                                            </td>
                                        </tr>
                                    ) : (
                                        paginaItems.map((paciente) => (
                                            <tr key={paciente.id}>
                                                <td>{getNombreClienteFacturacion(paciente)}</td>
                                                <td>{paciente.numero_documento || '—'}</td>
                                                <td className="text-center align-middle">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-success"
                                                        title="Seleccionar"
                                                        onClick={() => handleSelect(paciente)}
                                                    >
                                                        <i className="fas fa-check"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {!loading && filtrados.length > PACIENTES_POR_PAGINA && (
                            <div className="d-flex justify-content-between align-items-center mt-2 small text-muted">
                                <span>
                                    {inicio + 1}–{Math.min(inicio + PACIENTES_POR_PAGINA, filtrados.length)} de {filtrados.length}
                                </span>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary mr-1"
                                        disabled={pagina <= 1}
                                        onClick={() => setPaginaActual((p) => Math.max(1, p - 1))}
                                    >
                                        ‹
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        disabled={pagina >= totalPaginas}
                                        onClick={() => setPaginaActual((p) => Math.min(totalPaginas, p + 1))}
                                    >
                                        ›
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalSeleccionPaciente;
